import { Fragment } from "react/jsx-runtime";
import { Href } from "../../../Constants/Constants";
import { ContactIconData } from "../../../Data/Messenger/Messenger";
import SvgIcon from "../../CommonComponents/SvgIcon";
import SharedDocument from "../ChatBoard/CallContent/SharedDocument";

const ContactIcon = () => {
  return (
    <Fragment>
      <div className="contact-icon">
        <ul className="other-media-icon">
          {ContactIconData.map((item, index) => (
            <li key={index}>
              <a href={Href}>
                <SvgIcon className={item.svgClass} iconId={item.svgIcon} />
              </a>
              <h6>{item.title}</h6>
            </li>
          ))}
        </ul>
      </div>
      <div className="right-chat-content">
        <h5>Hey, I’m using chatifyyy 😍</h5>
      </div>
      <SharedDocument />
    </Fragment>
  );
};

export default ContactIcon;
